export enum BackpressureQueueWorker {
  SetPeriod = 'setPeriod',
  SetQueueCount = 'setQueueCount',
  ProcessQueue = 'processQueue',
  ProcessNextItem = 'processNextItem',
}

export type BackpressureQueueCommand =
  | SetPeriodCommand
  | SetQueueCountCommand
  | ProcessNextItemCommand
  | ProcessQueueCommand;

interface Command<T> {
  cmd: T;
}
interface Message<T> {
  message: T;
}

export class SetPeriodCommand implements Command<BackpressureQueueWorker>, Message<number> {
  public readonly cmd = BackpressureQueueWorker.SetPeriod;
  constructor(public readonly message: number) {}
}

export class SetQueueCountCommand implements Command<BackpressureQueueWorker>, Message<number> {
  public readonly cmd = BackpressureQueueWorker.SetQueueCount;
  constructor(public readonly message: number) {}
}

export class ProcessQueueCommand implements Command<BackpressureQueueWorker> {
  public readonly cmd = BackpressureQueueWorker.ProcessQueue;
  constructor() {}
}

export class ProcessNextItemCommand implements Command<BackpressureQueueWorker> {
  public readonly cmd = BackpressureQueueWorker.ProcessNextItem;
  constructor() {}
}
